import { DecimalPipe, registerLocaleData } from '@angular/common';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DefaultLayoutComponent } from './components/layouts/default-layout/default-layout.component';
import { LoggedLayoutComponent } from './components/logged-layout/logged-layout.component';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { SharedModule } from './modules/shared/shared.module';
import { AuthenticationService } from './services/authentication.service';
import { DataService } from './services/data.service';
import { FileServer } from './services/fileserver.service';
import { GeolocationService } from './services/geolocation.service';
import { NavigationService } from './services/navigation.service';
import { PusherService } from './services/pusher.service';
import { VeriftooService } from './services/veriftoo.service';
import { MessagingService } from './services/messaging.service';
import { environment } from '../environments/environment';
import firebase from 'firebase/app';

registerLocaleData(localeFr, 'fr');

firebase.initializeApp(environment.firebase.config);

export function initTranslations(translate: TranslateService) {
  return () => {
    translate.setDefaultLang('fr');
    return translate.use('fr').toPromise();
  };
}

export function createTranslateLoader(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/i18n/', suffix: '.json' },
    { prefix: './assets/i18n/', suffix: '.static.json' },
  ]);
}

@NgModule({
  declarations: [AppComponent, DefaultLayoutComponent, LoggedLayoutComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'veriftoo-webapp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    FlexLayoutModule,
    SharedModule,
    HttpClientModule,
    MatTooltipModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslations,
      deps: [TranslateService],
      multi: true,
    },
    AuthenticationService,
    DataService,
    TranslateService,
    NavigationService,
    FileServer,
    VeriftooService,
    PusherService,
    GeolocationService,
    MessagingService,
    DecimalPipe,
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    { provide: LOCALE_ID, useValue: 'en-US' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },

    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 2500, panelClass: ['snack-style'] },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private translate: TranslateService) {
    translate.addLangs(['fr', 'en']);
    translate.setDefaultLang('en');

    // const lang = window.navigator.language ? window.navigator.language.split('-')[0] : 'en';
    const lang = 'en';
    translate.use(lang);
  }
}
